'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var device_context = require('./device.context-f96381a3.js');
var device_consts = require('./device.consts-2b011893.js');
var mobileDetect = require('./mobile-detect-2421ba00.js');

var useDeviceIsSmallViewportWidth = function (smallDeviceMaxWidth) {
    var _a = tslib_es6.__read(React.useState(false), 2), value = _a[0], setValue = _a[1];
    React.useEffect(function () {
        var handleResize = function () {
            setValue(window.matchMedia("(max-width: " + smallDeviceMaxWidth + "px)").matches);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, [smallDeviceMaxWidth]);
    return value;
};
var useDeviceIsMobile = function () { return React.useMemo(function () {
    var mobileDetect$1 = new mobileDetect.mobileDetect(navigator.userAgent);
    return !!mobileDetect$1.mobile();
}, []); };
var useDeviceContextValue = function (smallDeviceMaxWidth) {
    var isSmallViewport = useDeviceIsSmallViewportWidth(smallDeviceMaxWidth);
    var isMobileDevice = useDeviceIsMobile();
    return React.useMemo(function () { return ({
        isSmallViewport: isSmallViewport,
        isMobileDevice: isMobileDevice,
    }); }, [isSmallViewport, isMobileDevice]);
};

var DeviceProvider = function (_a) {
    var children = _a.children, _b = _a.smallDeviceMaxWidth, smallDeviceMaxWidth = _b === void 0 ? device_consts.SMALL_DEVICE_MAX_WIDTH : _b;
    var contextValue = useDeviceContextValue(smallDeviceMaxWidth);
    return React__default.createElement(device_context.DeviceContext.Provider, { value: contextValue }, children);
};

exports.DeviceProvider = DeviceProvider;
